<!--suppress RedundantIfStatementJS, ES6ConvertVarToLetConst -->
<template>
  <div class='bg'>
    <div class='title'>
      我的奖品
    </div>
    <div v-if='list.length == 0' class='default'>
      <span>无中奖记录</span>
    </div>
    <List v-else v-model:loading='loading' :finished='finished' class='list' finished-text='没有更多了'>
      <div v-for="item in list" class="list-item">
        <div class="prize">
          <img v-if="item.awardImage" :src="item.awardImage" alt="" />
          <img v-else alt="" src="../../assets/img/person/prize/gift.png" />
        </div>
        <div class="center-info">
          <div class="prize-title">{{ item.awardName }}</div>
          <p class="prize-time">
            {{ dayjs(item.lotteryTime).format('YYYY.MM.DD HH:mm:ss') }}
          </p>
        </div>
        <div v-if="item.isSend === 2" class="more-btn" @click="handleNavToApp(item)">
          <span style="color: #dc3939">发放失败</span>
        </div>
        <template v-else>
          <div v-if="item.awardType === 2" class="more-btn">
            <span v-show="item.isSend === 1" @click="handleNavToApp(item)">去使用</span>
            <span v-show="item.isSend === 3" @click="handleNavToApp(item)">补录领取</span>

            <img v-show="item.awardType === 2" alt="" src="../../assets/img/person/prize/arrow-right.png" />
          </div>
          <template v-else>
            <div v-show="item.isSend === 3" class="more-btn" @click="handleNavToApp(item)">
              <span>补录领取</span>

              <img alt="" src="../../assets/img/person/prize/arrow-right.png" />
            </div>
          </template>
        </template>
      </div>
    </List>

  </div>
  <FormToast v-model="showForm" :activity="activity" @on-form-sumbit="handleFormSubmit" />
</template>

<script setup>
import { onMounted, ref } from 'vue'
import dayjs from 'dayjs'
import { useRoute } from 'vue-router'
import WebBridgeApi from "ijsbridge"
import FormToast from './formToast/index.vue'
import { List, Toast } from 'vant'
import { getDrawInfo } from '@/api/person'
import { fetchActivityInfo, fetchMyRecordList, updateRecordUser } from '@/api/prize-person'
import { useStore } from 'vuex'
import CryptoJS from 'crypto-js'
import { DOWNLOAD_URL, DOWNLOAD_URL_LY, DOWNLOAD_URL_SD_NEWS_IOS, DOWNLOAD_URL_SD_NEWS_ANDROID } from '@/constants'
import { isAndroid } from 'vant/lib/utils'

const route = useRoute()
const store = useStore()

const props = defineProps({
  modelValue: Boolean,
})

const emit = defineEmits(['modelValue', 'onJumpToDownload'])

const handleMaskClick = () => {
  emit('modelValue', false)
}

var isInApp = () => {
  const ua = navigator.userAgent;
  if (ua.indexOf("chuangqi") !== -1) {
    return true;
  }
  return false;
};

var jumpToAppCoupon = () => {
  WebBridgeApi.requestApi("router", {
    route: "coupon_my"
  });
};

const currentRecordId = ref(0)
const showForm = ref(false)

const handleNavToApp = (item) => {
  // 成功领取
  if (item.isSend === 1) {
    if (isInApp()) {
      jumpToAppCoupon()

      return
    }
    const orgId = route.query.orgId || 29

    if (orgid === '21') {
      if (isAndroid()) {
        window.location.href = DOWNLOAD_URL_SD_NEWS_ANDROID
      } else {
        window.location.href = DOWNLOAD_URL_SD_NEWS_IOS
      }
    } else if (orgid === '409') {
      window.location.href = DOWNLOAD_URL_LY
    } else {
      window.location.href = `${DOWNLOAD_URL}?orgid=${orgId}`
    }

  }

  // 补录领取
  if (item.isSend === 3) {
    console.log(item);
    currentRecordId.value = item.recordId
    showForm.value = true
    handleMaskClick()
  }
}

const list = ref([])
const loading = ref(false)
const finished = ref(true)

const activityId = ref('')
const orgid = ref('')
const activity = ref({})

// 根据抽奖链接获取activityId
const fetchActivityId = async () => {
  loading.value = true
  const res = await getDrawInfo({
    questionActiveKey: route.query.questionActiveKey,
    token: store.getters.getToken,
  }
  )
  console.log('根据抽奖链接获取activityId', res)
  if (res.ok) {
    const activityIdRegex = /activityId=([\d]+)/
    const orgidRegex = /orgid=([\d]+)/

    activityId.value = res.data.lotteryUrl.match(activityIdRegex)[1]
    orgid.value = res.data.lotteryUrl.match(orgidRegex)[1]

    // 中奖记录
    const resRecord = await fetchMyRecordList({
      activityId: activityId.value,
      isHit: 1,
      pageSize: 999
    },
      {
        token: store.getters.getToken,
        orgid: orgid.value
      }
    )
    console.log('中奖记录', resRecord)
    let resRecordData = JSON.parse(decrypt('9c9c502c96691826', resRecord))
    if (resRecordData && resRecordData.code === 1) {
      list.value = resRecordData.data.list
    }

    // 抽奖信息
    const resActivityInfo = await fetchActivityInfo({
      activityId: activityId.value,
    },
      {
        token: store.getters.getToken,
        orgid: orgid.value
      });
    console.log('抽奖信息', resActivityInfo)
    let resActivityInfoData = JSON.parse(decrypt('9c9c502c96691826', resActivityInfo))
    if (resActivityInfoData.code === 1) {
      activity.value = resActivityInfoData.data
      loading.value = false
    }
  }
}

// 解密
const decrypt = (key, word) => {
  // 秘钥
  const localKey = CryptoJS.enc.Utf8.parse(key)
  // 偏移量
  const iv = CryptoJS.enc.Utf8.parse('0000000000000000')
  const encryptedHexStr = CryptoJS.enc.Base64.parse(word)
  const srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr)
  const decrypt = CryptoJS.AES.decrypt(srcs, localKey, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })

  return CryptoJS.enc.Utf8.stringify(decrypt)
}

// 提交中奖信息
const handleFormSubmit = (data) => {
  console.log('提交中奖信息了', data)
  handleSubmitMyInfo({
    ...data,
    recordId: currentRecordId.value,
    getToken: store.getters.getToken,
    onSuccess: (data) => {
      fetchActivityId()
      Toast('补录成功')
    }
  })
}

const handleSubmitMyInfo = async (option) => {
  console.log('handleSubmitMyInfo--option', option)
  const localToken = option.getToken ? option.getToken : ''
  if (!localToken) return
  try {
    let { getToken, ...data } = option
    const res = await updateRecordUser(
      { ...data, token: localToken },
      { token: store.getters.getToken, orgid: orgid.value }
    );
    option.onSuccess && option.onSuccess(res.data)
  } catch (error) {
    console.log('error', error)
  }
}

onMounted(() => {
  fetchActivityId()
})
</script>

<style lang='scss' scoped>
.bg {
  .title {
    background-color: #FFBC01;
    height: 70px;
    margin: 0 25px;
    text-align: center;
    font-size: 36px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 70px;
    text-shadow: 0px 2px 10px rgba(101, 74, 0, 0.24);
  }

  .default {
    width: 450px;
    height: 350px;
    background-image: url("../../assets/img/person/rank-zanwu.png");
    background-size: 100% 100%;
    margin: 100px auto 0;
    text-align: center;

    span {
      font-size: 32px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #999999;
      position: relative;
      top: 290px;
      left: 0;
      right: 0;
    }
  }

  .list {
    margin-top: 30px;

    .list-item {
      position: relative;
      display: flex;
      align-items: center;
      margin: 0 auto;
      margin-bottom: 20px;
      box-sizing: border-box;
      padding-left: 26px;
      padding-right: 26px;
      width: 700px;
      height: 158px;
      background: #ffffff;
      border-radius: 5px;
      font-size: 30px;

      .prize {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 110px;
        height: 110px;

        img {
          width: 100%;
          // height: 100%;
        }
      }

      .center-info {
        margin-left: 15px;

        .prize-title {
          margin: 0;

          width: 208px;
          font-size: 30px;
          font-weight: 400;
          color: #333333;
          line-height: 36px;
        }

        .prize-time {
          margin: 0;
          margin-top: 10px;
          font-size: 28px;
          color: rgb(202, 202, 202);
        }
      }

      .more-btn {
        display: flex;
        align-items: center;
        position: absolute;
        margin: auto;
        top: 0;
        bottom: 0;
        right: 26px;
        font-size: 30px;
        font-weight: 400;
        color: #1f8eff;

        img {
          width: 40px;
        }
      }
    }
  }
}
</style>
